import { EVIDENCE_KIND_COST, EVIDENCE_KIND_INCOME } from '../evidence.js';
import { FILTERS } from './evidenceFilters';
import FiltersType from './listingFiltersTypesConstants.js';

const filters = [
  {
    key: 'evidencekind.id',
    getItems: async () => [{ value: EVIDENCE_KIND_INCOME, label: 'Przychód' }, { value: EVIDENCE_KIND_COST, label: 'Koszt' }],
    reset: async () => null,
    placeholder: 'Przychód/Koszt?',
    badge: 'Rodzaj:',
    testName: 'test_filter_evidence_evidencekind_id',
    inputType: FiltersType.SELECT_TYPE,
  },
  ...FILTERS,
];

export const KPIR_EVIDENCE_LISTING_FILTERS = {
  path: '/evidences/kpir',
  filters,
};
